/** A generated aggregate: one original image and its per-variant models. Shared by pillows and ornaments. */
export interface Detail<TModel> {
  id: string;
  image: { id: string; url: string };
  models: TModel[];
}

export interface Paged<T> {
  items: T[];
  page: number;
  pageSize: number;
  total: number;
}

/**
 * A superseded GLB/preview pair of a model. Regeneration always creates new blobs (the gateway
 * serves blobs as immutable), and the old pair is kept as a version so the history stays viewable.
 */
export interface ModelVersion {
  id: string;
  /** The old GLB. */
  url: string;
  /** The old preview / processed photo, when that version had one. */
  previewUrl: string | null;
  createdAt: string;
  supersededAt: string;
}

export interface PillowModel {
  id: string;
  color: string;
  url: string;
  previewId: string | null;
  previewUrl: string | null;
  printId: string | null;
  printUrl: string | null;
  previousVersions: ModelVersion[];
}

export type PillowDetail = Detail<PillowModel>;

export interface PillowGalleryItem {
  id: string;
  createdAt: string;
  previewUrl: string | null;
  previewColor: string | null;
  imageUrl: string;
}

/** Bow colours the ornament service accepts (`BowColors` in platform.contracts), with swatch hexes. */
export const BOW_COLORS = [
  { value: "red", label: "Red", hex: "#C8102E" },
  { value: "gold", label: "Gold", hex: "#D4AF37" },
  { value: "silver", label: "Silver", hex: "#C0C0C0" },
  { value: "white", label: "White", hex: "#FFFFFF" },
  { value: "green", label: "Green", hex: "#1E7F4A" },
  { value: "blue", label: "Blue", hex: "#1F4FA3" },
] as const;

export function bowColorHex(name: string): string {
  const entry = BOW_COLORS.find((c) => c.value === name);
  if (entry === undefined) throw new Error(`Unknown bow colour: "${name}"`);
  return entry.hex;
}

export interface OrnamentModel {
  id: string;
  bowColor: string;
  backgroundRemoved: boolean;
  /** The GLB. */
  url: string;
  /** The processed square photo that sits inside the ball. */
  photoId: string;
  photoUrl: string;
  previousVersions: ModelVersion[];
}

export type OrnamentDetail = Detail<OrnamentModel>;

export interface OrnamentGalleryItem {
  id: string;
  createdAt: string;
  photoUrl: string | null;
  bowColor: string | null;
  imageUrl: string;
}

/** Background-removal providers offered in the admin forms (the pipeline accepts more aliases). */
export const REMOVAL_MODES = [
  { value: "rembg", label: "rembg" },
  { value: "removebg-free", label: "remove.bg (free pool)" },
  { value: "remove.bg", label: "remove.bg" },
];
